export const SearchTypeCategoryId = 23 as const;
export type TSearchTypeCategoryId = typeof SearchTypeCategoryId;

/** elementSubType1 */
export enum CategoryType {
	ONLY = 2,
	ONLY_RECURSIVE = 0,
	EXCLUDE = 3,
	EXCLUDE_RECURSIVE = 1,
}
